export function statusBadge(status: string): string {
  const cls = status === 'active' || status === 'confirmed' || status === 'completed' || status === 'approved'
    ? 'badge-ok'
    : status === 'pending' || status === 'pencilled' || status === 'onboarding' || status === 'open' || status === 'assigned'
    ? 'badge-warn'
    : status === 'inactive' || status === 'cancelled' || status === 'denied'
    ? 'badge-err'
    : 'badge-muted';
  return `<span class="badge ${cls}">${escHtml(status)}</span>`;
}

function escHtml(str: string): string {
  const el = document.createElement('div');
  el.textContent = str;
  return el.innerHTML;
}
